import { HttpResponseError } from 'src/service/backend/error/HttpResponseError'

export class ClientError extends HttpResponseError {}
